import { Layout } from "antd";
import React, { Suspense } from "react";
import { Outlet } from "react-router-dom";
import ApplicationWrapper from "./AppWrapper";
import LoadingPage from "./LoadingPage";
import useUserDataStore from "hooks/useUserDataStore";

export default function Base(): React.ReactElement {
  const userData = useUserDataStore(state => state.userData);
  return (
    <Layout>
      {userData && <ApplicationWrapper />}
      <Suspense fallback={<LoadingPage />}>
        <Outlet />
      </Suspense>
    </Layout>
  );
}
